import Vue from 'vue';
import _ from 'lodash';
import { IFieldBase } from '~/types/ruleTypes';

export default class CommonTools {
    static titleCase(str: string) {
        return str
            .toLowerCase()
            .split(' ')
            .map(function(word) {
                return (
                    word
                        .toLocaleLowerCase()
                        .charAt(0)
                        .toLocaleUpperCase() + word.slice(1)
                );
            })
            .join(' ');
    }

    static sentenceCase(str: string) {
        const sentence = str
            .toLowerCase()
            .split(' ')
            .map(function(word) {
                return word.toLocaleLowerCase() + word.slice(1);
            })
            .join(' ');

        return sentence.charAt(0).toLocaleUpperCase() + sentence.slice(1);
    }

    static titleFormat(str: string) {
        return ((str.charAt(0).toLocaleUpperCase() + str.slice(1)).match(/[A-Z][a-z]+/g) || []).join(' ');
    }

    // Only define functions, looping thru attributes
    static fieldKeys(searchFields: IFieldBase) {
        const searchKeys = Object.getOwnPropertyNames(searchFields.getFieldDefaults());
        const parentKeys = Object.getOwnPropertyNames(new Vue());
        const returnKeys = _.difference(searchKeys, parentKeys);

        return returnKeys;
    }

    static pascalCase(str: string) {
        return _.startCase(_.camelCase(str || '')).replace(/ /g, '');
    }

    static safeToString(item: string) {
        return (item || '').toString();
    }

    static safeToLowerCase(item: string) {
        return (item || '').toLocaleLowerCase();
    }

    static safeToStringLowerCase(item: string) {
        return this.safeToLowerCase(this.safeToString(this.safeStringTrim(item)));
    }

    static safeStringTrim(item: string) {
        return (item || '').trim();
    }

    static phoneToString(item: string) {
        return (item || '').replace(/[^A-Z0-9]/gi, '');
    }

    static stringToPhone(item: string) {
        return (item || '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
    }

    static auth0StringToPhone(item: string) {
        return this.stringToPhone((item || '').replace(/\+1/, ''));
    }

    static toCurrencyFormat(number: number) {
        return Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(number);
    }
}
